/** CUSTOMER-R4.5 — production BANK_IBAN_ONLY: no NovaPay marks in Customer dist. */
import type { ReactNode } from "react";
import type { StoreV2Lang } from "./store-v2-locale.js";

export type PaymentMarkId = "novapay" | "visa" | "mastercard" | "apple_pay" | "google_pay";
export interface PaymentMarkDef {
  id: PaymentMarkId;
  label: string;
  src: string;
}
export const NOVAPAY_PAYMENT_MARKS: readonly PaymentMarkDef[] = [];
export const NOVAPAY_ACCEPTED_METHOD_LABELS = [] as const;
export const PAYMENT_MARK_ASSET_STATUS = "BANK_IBAN_ONLY" as const;

export function NovapaySandboxBadge(_props: { lang: StoreV2Lang; testId?: string }): null {
  return null;
}
export function NovapayPaymentHelper(_props: { lang: StoreV2Lang }): null {
  return null;
}
export function NovapayPayControl(_props: { lang: StoreV2Lang; children?: ReactNode }): null {
  return null;
}
export function NovapayPaymentOptionLabel(_props: { lang: StoreV2Lang }): null {
  return null;
}
export function NovapayAcceptedMethodsRow(_props: { lang: StoreV2Lang }): null {
  return null;
}
